/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import styles from './styles';

interface PropTypes {
  orString?: string;
}

const HorizontalRule: React.FC<PropTypes> = ({ orString }) => {
  return (
    <div>
      <hr css={styles.hr} data-content={orString ? orString : undefined} />
    </div>
  );
};

export default HorizontalRule;
